import React, { useEffect, useState } from "react";
import Gauche from "../home/gauche";
import Discussion from "./discussion";

import Header from "../header/header"
import Footer from '../footer/footer';
import Footer1 from '../footer/footer1';
import { useParams } from "react-router-dom";
import {
    Form,
    InputGroup,
    Button,
    Card,
    Col,
    Row,
    Pagination,
  } from "react-bootstrap";
import { baseApiUrl } from "../../../services/api";

function DiscussionDetail() {



    const { questionId } = useParams();
    const [question, setQuestion] = useState(null);
      const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur




    useEffect(() => {
        const fetchQuestion = async () => {
          try {
            const response = await baseApiUrl.get(`question/${questionId}`);
            console.log("Données reçues :", response.data);

            // Filtrer les réponses actives
            const questionWithActiveResponses = {
              ...response.data,
              reponses: response.data.reponses ? response.data.reponses.filter(reponse => reponse.actif === true) : []
            };

            setQuestion(questionWithActiveResponses);
          } catch (error) {
            console.error("Erreur lors de la récupération de la question :", error);
          }
        };

        fetchQuestion();
      }, [questionId]);




    return (
        <forum>
            <Header />
            <div
                className="inner-hero bg-cover"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-heading">

                                <h1>Forums</h1>
                                <h3 style={{ fontSize: "18px", color: "white" }}>
                  Le forum c'est l'espace ou chaque acteur peut dicuter avec les
                  autres auteurs sur des thematiques precis.
                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog1 sp bg1 _relative">
                <div className="container">
                    <div className="row">

                       <div className="col-lg-8">
                                                  {question && (
                                                      <div className="details content-area mt-40">
                                                          <div className="comments-area">
                                                              <div className="comment-box">
                                                                  <div className="top-area">
                                                                      <div className="author-area">
                                                                          <img
                                                                              src={question.utilisateur?.photo
                                                                                  ? baseApiUrl.defaults.baseURL + `/image/${question.utilisateur.photo}`
                                                                                  : "https://via.placeholder.com/50"
                                                                              }
                                                                              alt={question.utilisateur?.prenom}
                                                                              className="rounded-circle"
                                                                              width="50"
                                                                              height="50"
                                                                          />
                                                                          <div className="heading1 ml-20">
                                                                              <h4>{question.utilisateur?.prenom}</h4>
                                                                              <p className="mt-2">{new Date(question.creationDate).toLocaleDateString()}</p>
                                                                          </div>
                                                                      </div>

                                                                      {/* <Button variant="link" size="sm" disabled={!currentUser}>
                                                                          <i className="fa-solid fa-reply"></i> Répondre
                                                                      </Button> */}
                                                                  </div>

                                                                  <span className="text-muted">{question.categorie?.nom}</span>
                                                                  <div className="heading1 mt-20">
                                                                      <p>{question.description}</p>
                                                                  </div>
                                                              </div>

                                                              <Row className="mt-2">
                                                                  {question.reponses && question.reponses.length > 0 ? (
                                                                      question.reponses.map((reponse, index) => (
                                                                          <Card key={index} className="mb-2 p-2" style={{ backgroundColor: "#F0F0F0", borderRadius: "10px" }}>
                                                                              <Row>
                                                                                  <Col md={1}>
                                                                                      <img
                                                                                          src={reponse.utilisateur?.photo
                                                                                              ? baseApiUrl.defaults.baseURL + `/image/${reponse.utilisateur.photo}`
                                                                                              : "https://via.placeholder.com/50"
                                                                                          }
                                                                                          alt={reponse.utilisateur?.prenom}
                                                                                          className="rounded-circle"
                                                                                          width="50"
                                                                                          height="50"
                                                                                      />
                                                                                  </Col>
                                                                                  <Col md={11}>
                                                                                      <h6 className="mb-1">
                                                                                          <strong>{reponse.utilisateur?.prenom}</strong>
                                                                                          <span className="ms-2 text-muted">{new Date(reponse.created).toLocaleString()}</span>
                                                                                      </h6>
                                                                                      <div className="text-muted mb-1">
                                                                                          <p style={{ color: "#000000" }}>{reponse.contenu}</p>
                                                                                      </div>
                                                                                  </Col>
                                                                              </Row>
                                                                          </Card>
                                                                      ))
                                                                  ) : (
                                                                      <p>Aucune réponse pour le moment.</p>
                                                                  )}
                                                              </Row>

                                                              {currentUser && (
                                                                  <div className="details-contact-area">
                                                                      <div className="heading1">
                                                                          <h5 className="text-center">Poser une question</h5>
                                                                      </div>
                                                                      <Form>
                                                                          <Form.Group controlId="questionTitle">
                                                                              <Form.Label>Titre</Form.Label>
                                                                              <Form.Control type="text" placeholder="Titre" />
                                                                          </Form.Group>
                                                                          <Form.Group controlId="questionCategory">
                                                                              <Form.Label>Catégorie</Form.Label>
                                                                              <Form.Select>
                                                                                  <option>Choisir une catégorie</option>
                                                                                  {/* Remplir dynamiquement */}
                                                                              </Form.Select>
                                                                          </Form.Group>
                                                                          <Form.Group controlId="questionDescription">
                                                                              <Form.Label>Description</Form.Label>
                                                                              <Form.Control as="textarea" rows={3} placeholder="Décrivez votre question" />
                                                                          </Form.Group>
                                                                          <Button variant="primary" type="submit" className="mt-3">
                                                                              Publier
                                                                          </Button>
                                                                      </Form>
                                                                  </div>
                                                              )}
                                                          </div>
                                                      </div>
                                                  )}
                                              </div>


                    </div>
                </div>
            </div>

            <Footer1 />

            <Footer />


        </forum>
    );
}

export default DiscussionDetail;
